import './IconPlus.css';
import React from 'react';
const IconPlus = _ref => {
  let {
    width = 20,
    height = 20,
    className
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 20 20",
    className: `${className} ${styles}`
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M11 5v4h4v2h-4v4H9v-4.001L5 11V9l4-.001V5h2z"
  }));
};
const styles = "s18w4e2n";
export default IconPlus;